import type { Domain } from "@rema/shared/schemas/domains"
import { ConfirmDialog } from "../../components/confirm-dialog"
import { domainsI18n as i18n } from "./i18n"

// Confirmación de suspensión/activación (F4.6): suspender bloquea los logins de todo
// el dominio, así que es destructivo y se confirma con verbo explícito (docs/05 §3).
export interface SuspendDomainDialogProps {
  // null = cerrado; un dominio = abierto sobre ese dominio
  domain: Domain | null
  confirming: boolean
  onConfirm: (domain: Domain) => void
  onCancel: () => void
}

export const SuspendDomainDialog = ({
  domain,
  confirming,
  onConfirm,
  onCancel,
}: SuspendDomainDialogProps) => {
  const suspending = domain?.status === "active"
  return (
    <ConfirmDialog
      open={domain !== null}
      title={suspending ? i18n.suspend.title : i18n.activate.title}
      message={suspending ? i18n.suspend.message : i18n.activate.message}
      confirmLabel={suspending ? i18n.suspend.confirm : i18n.activate.confirm}
      danger={suspending}
      confirming={confirming}
      onConfirm={() => {
        if (domain) onConfirm(domain)
      }}
      onCancel={onCancel}
    />
  )
}
